import { createApp } from 'vue'
import Yas from './Yas.vue'
import './assets/global.css'

createApp(Yas).mount('#yas')
